<app-collapsible-section 
title="Email"
[isExpanded]="isExpanded"
[isCompleted]="isCompleted"
[showDoneButton]="true"
(toggle)="onEmailToggle($event)"
(done)="onEmailDone()">
<ng-template #sectionContent>
  <div class="email-content">

         <!-- here -->
      <!-- Create Email Campaign Input - Only show if no email content exists -->
      <div class="create-email-input" *ngIf="!hasEmailContent" (click)="onCreateEmailCampaign()">
        <div class="input-content">
          <span class="input-text">Create Email Campaign</span>
        </div>
        <div class="plus-icon">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7 1V13M1 7H13" stroke="#0030A8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      </div>

      <!-- Email Templates List -->
      <div class="email-templates" *ngIf="hasEmailContent" >
      <div class="email-template-item" *ngFor="let template of emailTemplates; trackBy: trackByIndex">
        <div class="template-info">
          <div class="subject">Subject: {{ sampleEmailData.subject }}</div>
          <div class="from">From: {{ sampleEmailData.fromEmail }}</div>
        </div>
        <div class="template-actions">
          <!-- <button class="action-btn view-btn" title="View" (click)="onViewTemplate(template)">
            <svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.66667 5C5.66667 5.35362 5.80714 5.69276 6.05719 5.94281C6.30724 6.19286 6.64638 6.33333 7 6.33333C7.35362 6.33333 7.69276 6.19286 7.94281 5.94281C8.19286 5.69276 8.33333 5.35362 8.33333 5C8.33333 4.64638 8.19286 4.30724 7.94281 4.05719C7.69276 3.80714 7.35362 3.66667 7 3.66667C6.64638 3.66667 6.30724 3.80714 6.05719 4.05719C5.80714 4.30724 5.66667 4.64638 5.66667 5Z" stroke="#15172E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M13 5C11.4 7.66667 9.4 9 7 9C4.6 9 2.6 7.66667 1 5C2.6 2.33333 4.6 1 7 1C9.4 1 11.4 2.33333 13 5Z" stroke="#15172E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                
          </button> -->
          <button class="action-btn edit-btn" title="Edit" (click)="onEditTemplate(template)">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3.66699 3.66674H3.00033C2.6467 3.66674 2.30756 3.80721 2.05752 4.05726C1.80747 4.30731 1.66699 4.64645 1.66699 5.00007V11.0001C1.66699 11.3537 1.80747 11.6928 2.05752 11.9429C2.30756 12.1929 2.6467 12.3334 3.00033 12.3334H9.00033C9.35395 12.3334 9.69309 12.1929 9.94313 11.9429C10.1932 11.6928 10.3337 11.3537 10.3337 11.0001V10.3334M9.66699 2.3334L11.667 4.3334M12.5903 3.39007C12.8529 3.12751 13.0004 2.77139 13.0004 2.40007C13.0004 2.02875 12.8529 1.67264 12.5903 1.41007C12.3278 1.14751 11.9716 1 11.6003 1C11.229 1 10.8729 1.14751 10.6103 1.41007L5.00033 7.00007V9.00007H7.00033L12.5903 3.39007Z" stroke="#15172E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                
          </button>
          <button class="action-btn delete-btn" title="Delete" (click)="onDeleteTemplate(template)">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.66699 3.66667H12.3337M5.66699 6.33333V10.3333M8.33366 6.33333V10.3333M2.33366 3.66667L3.00033 11.6667C3.00033 12.0203 3.1408 12.3594 3.39085 12.6095C3.6409 12.8595 3.98004 13 4.33366 13H9.66699C10.0206 13 10.3598 12.8595 10.6098 12.6095C10.8598 12.3594 11.0003 12.0203 11.0003 11.6667L11.667 3.66667M5.00033 3.66667V1.66667C5.00033 1.48986 5.07056 1.32029 5.19559 1.19526C5.32061 1.07024 5.49018 1 5.66699 1H8.33366C8.51047 1 8.68004 1.07024 8.80506 1.19526C8.93009 1.32029 9.00033 1.48986 9.00033 1.66667V3.66667" stroke="#AF1820" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                
          </button>
        </div>
      </div>
    </div>

    <!-- Email Preview -->
    <div class="email-preview" *ngIf="hasEmailContent">
      <div class="preview-placeholder">
        <app-email-preview
        [emailData]="sampleEmailData">
      </app-email-preview>
      </div>
    </div>
    <div class="form-footer">
        <button class="btn btn-primary btn-medium" (click)="onEmailDone()">{{hasEmailContent ? 'Done' : 'Create '}}</button>
    </div>
  </div>
</ng-template>
</app-collapsible-section>

<!-- Create Email Modal -->
<app-create-email-modal 
  *ngIf="showCreateModal"
  (close)="onCloseModal()"
  (save)="onSaveEmail($event)">
</app-create-email-modal>

<!-- Edit Email Modal -->
<app-create-email-modal 
  *ngIf="showEditModal"
  [initialData]="sampleEmailData"
  (close)="onCloseEditModal()"
  (save)="onSaveEditEmail($event)">
</app-create-email-modal>